import { Injectable } from '@angular/core';
import * as jQuery from 'jquery';

import { StateService } from './state.service';

@Injectable()
export class UiService {
  constructor(private _stateService: StateService) {
    this._stateService.isMobileLayout = this.isMobile();

    this.bindWindowResize(() => {
      const newLayoutIsMobile = this.isMobile();
      if (newLayoutIsMobile !== this._stateService.isMobileLayout) {
        this._stateService.mobileLayoutChanged(newLayoutIsMobile);
      }
    });

    this.onWindowLoad();
  }

  isMobile(): boolean {
    const isMobile = jQuery('#ismobile').css('display') === 'block';
    return isMobile;
  }

  scrollToTop(): void {
    window.scroll(0, 0);
  }

  onWindowLoad(): void {
    jQuery(document).ready(() => {
      this.drawCurveSvgHeader();
      this.initiateMulticolorDropdown();
    });
  }

  /**
   * Resets the size of the autocomplete dropdown, it's different size on mobile and deskop,
   * also this is called on window.resize.
   * @param componentId - Html id of the autocomplete component
   */
  autocompleteResetDropdownWidth(componentId: string): void {
    const jqInputBox = jQuery('#' + componentId + ' input');
    let autoCompleteWidth = jqInputBox.outerWidth();

    // Custom width for the keyword input, it has to span the width of the keyword and location inputs.
    // In Mobile layout the inputs are stacked in a column.
    // The extended dropdown width is only for the non-mobile layout when inputs are side by side.
    const isMobile = this.isMobile();
    // My location box is shown instead of the location autocomplete when My Location was selected
    // Use my-location-container to size the keyword autocomplete box.
    const isUsingMyLocation = jQuery('#location-autocomplete').css('display') === 'none';
    if (!isMobile && componentId === 'keywords-autocomplete') {
      let jqLocationBox = jQuery('#location-autocomplete input');
      if (isUsingMyLocation) {
        jqLocationBox = jQuery('#my-location-container');
      }
      autoCompleteWidth = autoCompleteWidth + jqLocationBox.outerWidth() - 1;
    }
    jQuery('#' + componentId + ' .input-autocomplete').width(autoCompleteWidth);
  }

  /**
   * Draws a curved SVG vector below the masthead image
   */
  drawCurveSvgHeader(): void {
    const w = jQuery(window).width();
    const d = 11 + Math.max(((w - 375) / 825) * 6, 0);

    jQuery('#header-svg-curve')
      // eslint-disable-next-line max-len
      .html(
        '<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" version="1.1"><path d="M0 0 C ' +
          w / 4 +
          ' ' +
          d +
          ', ' +
          (w - w / 4) +
          ' ' +
          d +
          ', ' +
          w +
          ' 0 L ' +
          w +
          ' 30 L 0 30 L 0 0" fill="#f5fbff"></path></svg>',
      );
  }

  /**
   * Bind a key down event to a custom event handler
   * @param elementSelector - Can be a string like '#someId' or object like document.
   * @param eventHandler - Event handling function
   */
  bindKeyDown(elementSelector: any, eventHandler: (event) => any) {
    jQuery(elementSelector).keydown(eventHandler);
  }

  bindWindowResize(eventHandler: (event) => any) {
    jQuery(window).resize(eventHandler);
  }

  toggleClass(selector: string, className: string) {
    jQuery(selector).toggleClass(className);
  }

  slideToggle(selector: string) {
    jQuery(selector).slideToggle();
  }

  setFocus(selector: string) {
    jQuery(selector).focus();
  }

  /**
   * Returns current browser url. Used by the report incorrect details function to grab the current url.
   */
  getCurrentUrl() {
    return window.location.href;
  }

  toggleParentClass(selector: any, parentSelector: string, className: string) {
    jQuery(selector).parent(parentSelector).toggleClass(className);
  }

  hasClass(element: any, className: string): boolean {
    return jQuery(element).hasClass(className);
  }

  /**
   * Enables window scroll when user clicks on AP or EC tabs on the home screen in mobile mode.
   */
  scrollToAPvsEC(): void {
    if (jQuery('hcf-app.mobile hcf-home .two-columns').offset() === undefined) {
      return;
    }

    jQuery('html, body').animate(
      {
        scrollTop: jQuery('hcf-app.mobile hcf-home .two-columns').offset().top,
      },
      1000,
    );
  }

  /**
   * Plugs in the multicolor dropdown functionality.
   */
  initiateMulticolorDropdown(): void {
    jQuery('.custom-select-box').click(function () {
      jQuery(this).toggleClass('open');
      jQuery(this).parent().parent().toggleClass('open');
    });

    jQuery('.custom-select-box .li').click(function () {
      jQuery(this).parent().find('.li').removeClass('select');
      jQuery(this).addClass('select');
      jQuery(this).parent().parent().find('.selected').text(jQuery(this).text());
      jQuery(this).parent().parent().parent().find('input').val(jQuery(this).text());
      jQuery(this).parent().parent().trigger('change');
    });

    jQuery('#login-select').on('change', () => {
      jQuery('#btn-sc-dd-login').attr('href', jQuery('#login-select .ul .li.select').attr('data-url'));
      jQuery('#btn-sc-dd-login').removeClass();
      jQuery('#btn-sc-dd-login').addClass('btn ' + jQuery('#login-select .ul .li.select').attr('data-btnclass'));
    });
  }
}
